import { INPUT_AUTOCOMPLETE, INPUT_TYPE } from '@nandosaus/constants';
import { useRootStore } from '@nandosaus/state-management';
import React, { useCallback, useState } from 'react';

import { Box } from '../grid';
import { Form } from '../form';
import { FormikTextInput } from '../input';
import { useSchema } from '../../hooks/use-schema';

const UpdateDetailsForm = () => {
  const [error, setError] = useState();
  const { MemberStore } = useRootStore();
  const { profile } = MemberStore;
  const validationSchema = useSchema('updateDetails');

  const initialValues = { mobile: '' };

  const onSubmit = useCallback(
    async values => {
      const { error: err = null } = await MemberStore.updateProfile(values);
      setError(err);
    },
    [MemberStore]
  );
  const heading = `Sorry to interrupt ${profile.givenName}!`;
  const paragraph = 'We’re missing some required details from your profile, can you please update the below fields.';

  return (
    <Form
      buttonText="Update Profile"
      error={error}
      heading={heading}
      paragraph={paragraph}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Box mb={2}>
        <FormikTextInput
          name="mobile"
          label="mobile number"
          type={INPUT_TYPE.PHONE}
          autoComplete={INPUT_AUTOCOMPLETE.PHONE}
        />
      </Box>
    </Form>
  );
};

export { UpdateDetailsForm };
